import { FunctionalComponent, h } from "preact";
import PortalLogo from "../PortalLogo";
import styles from "./styles.css";
import { useAppSelector } from "../../redux/hooks";
import { useAuth0 } from "@auth0/auth0-react";
import { Utils } from "../../utils";
import ExpandView from "../ExpandView";
import { useState } from "preact/hooks";
import { getIsEdge } from "../../configs/env";
import logger from "../../logger";
import { useEffect } from "react";
import InfoModal from "./InfoModal";
interface IProps {
  handleExpandView: () => void;
  goHome: () => void;
  isPaying?: boolean;
  homeUrl: string;
}
const Header: FunctionalComponent<IProps> = ({
  handleExpandView,
  isPaying,
  goHome,
  homeUrl,
}) => {
  const auth = useAppSelector((state) => state.auth);
  const appearance = useAppSelector((state) => state.appearance);
  const alias = useAppSelector((state) => state.alias);
  const { logout } = useAuth0();
  const [shareButtonText, setShareButtonText] = useState(
    appearance.resultSrc ? "Share Highlight" : "Share"
  );
  const [showToaster, setShowToaster] = useState("");
  const [isEdge, setIsEdge] = useState<boolean | undefined>(getIsEdge());
  const [showInfo, setShowInfo] = useState(false);
  useEffect(() => {
    setShareButtonText(appearance.resultSrc ? "Share Highlight" : "Share");
  }, [appearance.resultSrc]);
  const copyToClipboard = async () => {
    try {
      setShowToaster("Link copied");
      setTimeout(() => {
        setShowToaster("");
      }, 1000);
      setShareButtonText("Link copied!");
      const hostWithProtocol = window.location.host.startsWith("http")
        ? window.location.host
        : `https://${window.location.host}`;

      await navigator.clipboard.writeText(
        appearance.resultSrc
          ? `${hostWithProtocol}${appearance.resultSrc}`
          : homeUrl
      );

      setTimeout(() => {
        setShareButtonText(appearance.resultSrc ? "Share Highlight" : "Share");
      }, 300);
    } catch (error) {
      logger.error({
        message: "Failed to copy text to clipboard",
        error: error,
        stacktrace: (error as any)?.stack,
        portal_alias: alias.portalAlias,
        home_url: homeUrl,
      });
    }
  };
  return (
    <>
      <InfoModal showInfo={showInfo} setShowInfo={setShowInfo} />
      <div className={styles.headerWrapper}>
        <div>
          <PortalLogo goHome={goHome} />
        </div>
        <div className={styles.buttonContainerLg}>
          {appearance.isPrivate &&
          !auth.haveSSO &&
          appearance.mode !== "widget" ? (
            <span
              className={styles.logoutButton}
              style={{ color: appearance.preview ? "lightgray" : "" }}
              onClick={() => {
                if (!appearance.preview) {
                  if (auth.auth0User) {
                    logout();
                  } else {
                    if (isEdge) {
                      Utils.edgeLogout();
                    } else {
                      Utils.localLogout();
                    }
                  }
                }
              }}
            >
              Log out
            </span>
          ) : null}
          {!isEdge && (
            <button
              className={styles.shareButton}
              style={{ backgroundColor: appearance.preview ? "lightgray" : "" }}
              onClick={copyToClipboard}
              disabled={appearance.preview}
            >
              {shareButtonText}
            </button>
          )}
          <button
            style={{
              width: "60px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#344054",
              borderRadius: "32px",
            }}
            onClick={() => setShowInfo(!showInfo)}
            disabled={appearance.preview}
          >
            <svg
              fill="#ffffff"
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 416.979 416.979"
              xmlSpace="preserve"
              stroke="#ffffff"
              width={18}
              height={18}
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <g>
                  {" "}
                  <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"></path>{" "}
                </g>{" "}
              </g>
            </svg>
          </button>
        </div>
        <div className={styles.buttonContainer}>
          {appearance.isPrivate &&
          !auth.haveSSO &&
          appearance.mode !== "widget" ? (
            <span
              className={styles.logoutButton}
              style={{ color: appearance.preview ? "lightgray" : "" }}
              onClick={() => {
                if (!appearance.preview) {
                  if (auth.auth0User) {
                    logout();
                  } else {
                    if (isEdge) {
                      Utils.edgeLogout();
                    } else {
                      Utils.localLogout();
                    }
                  }
                }
              }}
            >
              Log out
            </span>
          ) : null}
          {!appearance.preview && (
            <img
              src="/assets/widget/share.svg"
              style={{ cursor: "pointer" }}
              onClick={copyToClipboard}
            />
          )}

          {appearance.mode === "widget" && (
            <ExpandView
              handleExpandView={handleExpandView}
              isPaying={isPaying}
            />
          )}
        </div>
        {showToaster && (
          <div className={`${styles.toasterBanner}`}>{showToaster}</div>
        )}
      </div>
    </>
  );
};

export default Header;
